import React from 'react';
// import "../../Components/text.css";
// import "../../Home/Components/Expertise.css";

export default function Peopletab({ image, Name, Title }) {
  return (
    <div
      // style={{
      //   display: "flex",
      //   flexDirection: "column",
      //   alignItems: "center",
      //   justifyContent: "center",
      //   textAlign: "center",
      // }}
    >
      {/* Circle image */}
      <div
        style={{
          height: 280,
          width: 280,
          borderRadius: "144px",
          overflow: "hidden",
          display: "flex",
          // justifyContent: "center",
          // alignItems: "center",
        }}
      >
        <img
          src={image}
          alt={Name}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>

      {/* Text below image */}
      <p className="maintext">{Name}</p>
      {Array.isArray(Title) ? (
        <>
          <p className="lighttext">{Title[0]}</p>
          <p className="lighttext">{Title[1]}</p>
        </>
      ) : (
        <p className="lighttext">{Title}</p>
      )}
    </div>
  );
}